<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <wj-tab-panel [selectedIndex]="0">
                <wj-tab>
                    <a>分析</a>
                    <div class="card">
                        <div class="card-header">
                            分析
                        </div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label d-none d-lg-block">対象</label>
                                <div class="col-md-9">
                                    <select class="form-control" [(ngModel)]="mode">
                                        <option [value]="'ヘッダ'">ヘッダ</option>
                                        <option [value]="'明細'">明細</option>
                                        <option [value]="'特殊'">特殊</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row" [hidden]="mode != '特殊'">
                                <label class="col-md-3 form-control-label d-none d-lg-block">レポート名</label>
                                <div class="col-md-6">
                                    <select class="form-control" [(ngModel)]="report">
                                        <option [value]="'お問い合わせ実績'">お問い合わせ実績</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label d-none d-lg-block">日付</label>
                                <div class="col-md-3">
                                    <wj-input-date #fromDateInput (valueChanged)="onChangeFromDate()"  style="width:100%;" style="width:100%;" [(value)]="fromDate"
                                                   [format]="'yyyy/MM/dd'" [isRequired]="false"
                                                   [placeholder]="'から'"></wj-input-date>
                                </div>
                                <div class="col-md-3">
                                    <wj-input-date #toDateInput style="width:100%;" style="width:100%;" [(value)]="toDate"
                                                   [format]="'yyyy/MM/dd'" [isRequired]="false"
                                                   [placeholder]="'まで'"></wj-input-date>
                                </div>
                                <div class="col-md-3">
                                    <button (click)="updateSpreadsheet()" class="btn btn-success btn-block">スプレッドシート反映</button>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label d-none d-lg-block">検索</label>
                                <div class="col-md-3">
                                    <input type="text" [(ngModel)]="keyword" class="form-control" placeholder="検索">
                                </div>
                                <div class="col-md-3">
                                    <button (click)="search()" class="btn btn-primary btn-block">検索</button>
                                </div>
                                <div class="col-md-3">
                                    <button (click)="export('pivotGrid','買取分析')" class="btn btn-success btn-block">エクスポート</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-2">
                                    <wj-pivot-panel [itemsSource]="pivot"></wj-pivot-panel>
                                </div>
                                <div class="col-sm-10">
                                    <wj-pivot-grid #pivotGrid [itemsSource]="pivot"></wj-pivot-grid>
                                </div>
                            </div>
                        </div>
                    </div>
                </wj-tab>
                <wj-tab>
                    <a>元データ</a>
                    <div class="card">
                        <div class="card-header">
                            元データ
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <wj-flex-grid #orderGrid [isReadOnly]="true" [selectionMode]="'Row'" style="height:500px" [itemsSource]="orders">
                                        <wj-flex-grid-filter></wj-flex-grid-filter>
                                        <wj-flex-grid-column [header]="'番号'" [binding]="'番号'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'枝番'" [binding]="'枝番'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'名前'" [binding]="'名前'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'買取区分'" [binding]="'買取区分'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'最終区分'" [binding]="'最終区分'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'部門'" [binding]="'部門'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'担当者'" [binding]="'担当者'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'見積担当者'" [binding]="'見積担当者'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'都道府県'" [binding]="'都道府県'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'受付日'" [binding]="'受付日'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'買取開始日時'" [binding]="'買取開始日時'" [width]="100"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'買取終了日時'" [binding]="'買取終了日時'" [width]="100"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'商品名'" [binding]="'商品名'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'メーカー'" [binding]="'メーカー'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'型番'" [binding]="'型番'" [width]="150"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'数量'" [binding]="'数量'" [width]="100"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'単価'" [binding]="'単価'" [width]="100"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'金額'" [binding]="'金額'" [width]="100"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'日付'" [binding]="'日付'" [width]="100"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'大分類'" [binding]="'大分類'" [width]="100"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'中分類'" [binding]="'中分類'" [width]="100"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'小分類'" [binding]="'小分類'" [width]="100"></wj-flex-grid-column>
                                        <wj-flex-grid-column [header]="'値'" [binding]="'値'" [width]="100"></wj-flex-grid-column>
                                    </wj-flex-grid>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button (click)="export('orderGrid','買取情報')" class="btn btn-primary btn-block">エクスポート
                            </button>
                        </div>
                    </div>
                </wj-tab>
            </wj-tab-panel>
        </div>
    </div>
</div>
